module.exports = __webpack_public_path__ + "static/media/video-calling.f3b87d58.png";